import React from 'react';
import Styles from 'components/footer/Footer.module.scss';

interface FooterProps {
  isVisible?: boolean;
}

const Footer: React.FC<FooterProps> = () => (
  <footer className={Styles.footer}>
    <span>© {new Date().getFullYear()}. All Rights Reserved.</span>
  </footer>
);

export default Footer;
